"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.centsToCurrencyString = void 0;
function centsToCurrencyString(valueCents, roundToCents = false) {
    const dollars = valueCents / 100;
    const showNegative = roundToCents ? dollars <= -0.005 : dollars <= -0.5;
    const dollarsString = Math.abs(dollars).toLocaleString('en-US', {
        maximumFractionDigits: roundToCents ? 2 : 0,
    });
    return `${showNegative ? '-' : ''}$${dollarsString}`;
}
exports.centsToCurrencyString = centsToCurrencyString;
